import {route} from "@/functions/route";
import {updateUrlQuery} from "@/functions/updateUrlQuery";
import Stringer from "@/packages/stringer/src/Stringer";
import _ from "lodash";

const processRoute = (routeName, parameters = []) => {
	if (typeof routeName !== "function") {
		return route(routeName, parameters);
	}
	return route(routeName(parameters), parameters);
};

const getDefaultState = () => {
	return {
		columns: Object,
		items: [],
		actions: [],
		links: Object,
		loaded: false,
		gettingModels: false,
		gettingModel: false,
		downloading: false,

		filters: Object,
		meta: Object,
		stats: Object,
		query: Object,
		activeItem: null,
	};
};

const state = getDefaultState();

const actions = {
	reset({commit}) {
		commit("RESET");
	},
	getModels({state, commit, dispatch}, page) {
		state.gettingModels = true;
		let query = state.query;
		query.page = page || 1;
		return new Promise((resolve, reject) => {
			return http().get(
				processRoute(state.routes.index),
				{
					params: query,
				}).then(response => {
				commit("UPDATE_ITEMS", response);
				updateUrlQuery(response);
				state.gettingModels = false;
				resolve(response);
			});
		});
	},
	activateModel({state, commit, dispatch}, payload) {
		return dispatch("getModel", payload).then(data => {
			commit("SET_ACTIVE_ITEM", data);
		});
	},
	refreshModel({state, commit, dispatch}, payload) {
		payload = {
			model: payload || state.activeItem,
			preserveActiveItem: true,
		};
		return dispatch("getModel", payload).then(data => {
			commit("SET_ACTIVE_ITEM", data);
		});
	},
	replaceModel({commit}, payload) {
		commit("UPDATE_ITEM", payload);
	},
	getModel({state, commit}, payload) {
		let preserveActiveItem = payload?.preserveActiveItem || false;
		payload = payload?.model || payload;

		if (!preserveActiveItem) {
			commit("SET_ACTIVE_ITEM", null);
		}

		return new Promise((resolve, reject) => {
			http().get(processRoute(state.routes.show, payload)).then(response => {
				resolve(response.data.data);
			}).catch(error => {
				console.log(error);
			});
		});
	},
	addModel({state, commit, dispatch}, item) {
		if (!state.loaded) {
			return dispatch("getModels");
		}

		if (state.meta.current_page > 1) {
			return;
		}

		if ("string" !== typeof item) {
			return commit("ADD_ITEM", item);
		}

		return new Promise((resolve, reject) => {
			return http().get(processRoute(state.routes.show, item)).then(response => {
				commit("ADD_ITEM", response.data.data);
				resolve();
			});
		});
	},
	updateModel({state, commit, dispatch}, item) {
		let id = "string" === typeof item ? item : item.id;

		if (
			state.items.findIndex(item => item.id === id) < 0 &&
			state.activeItem?.id !== id
		) {
			return;
		}

		if ("string" !== typeof item) {
			commit("UPDATE_ITEM", item);

			if (state.activeItem?.id === item.id) {
				commit("SET_ACTIVE_ITEM", item);
			}

			return;
		}

		return new Promise((resolve, reject) => {
			return http().get(processRoute(state.routes.show, item)).then(response => {
				commit("UPDATE_ITEM", response.data.data);

				if (state.activeItem.id === id) {
					commit("SET_ACTIVE_ITEM", response.data.data);
				}

				resolve();
			});
		});
	},
	goToPage({dispatch}, page) {
		return dispatch("getModels", page);
	},
	paginate({commit, dispatch}, perPage) {
		commit("SET_PER_PAGE", perPage);
		return dispatch("getModels", 1);
	},
	clearFilter({state, dispatch}, key) {
		let query = state.query;
		_.unset(query, key);
		return dispatch("filter", query);
	},
	filter({commit, dispatch}, query) {
		query = query ?? Qs.parse(new Stringer(window.location.search).lTrim("\\?").value) ?? {};
		commit("SET_QUERY", query);
		return dispatch("getModels", 1);
	},
	refresh({state, dispatch}) {
		return dispatch("getModels");
	},
	// download({state, commit, dispatch}, payload) {
	// 	console.log("crud.download", payload);
	// 	payload = {
	// 		path: state.routes.index + "/download",
	// 	};
	// 	dispatch("downloadsStore/download", {
	// 		path: state.routes.index + "/download",
	// 	}, {root: true});
	// 	return;
	// 	state.downloading = true;
	// 	payload.headers = {
	// 		"Accept-Encoding": "",
	// 	};
	// 	payload.responseType = "stream";
	// 	if (payload.filtered) {
	// 		payload.params = {
	// 			filter: state.query.filter,
	// 		};
	// 	}
	// 	return new Promise((resolve, reject) => {
	// 		return http(true).get(processRoute(state.routes.index + "/download"), payload).then(response => {
	// 			resolve(response);
	// 		}).catch(error => {
	// 			reject(error);
	// 		}).finally(() => {
	// 			state.downloading = false;
	// 		});
	// 	});
	// },
	set(state, payload) {
		// console.log("set", payload);
	},
};

const mutations = {
	RESET(state) {
		Object.assign(state, getDefaultState());
	},
	SET_PER_PAGE(state, perPage) {
		state.meta.per_page = perPage;
	},
	SET_QUERY(state, query) {
		state.query = query;
	},
	UPDATE_ITEMS(state, response) {
		state.actions = response.data.actions || [];
		state.columns = response.data.columns || [];
		state.items = Object.keys(response.data.data.models).map((key) => {
			return response.data.data.models[key];
		});
		// state.items = response.data.data.models ? response.data.data.models : response.data.data;
		state.links = response.data.links || state.links;
		state.meta = response.data.meta || state.meta;
		// state.query = Object.assign({}, state.query, {
		// 	filter: response.data.appliedFilters || {},
		// });
		// _.set(this, "query", response.data.data.appliedFilters ?? {});
		state.filters = response.data.filters || state.filters;
		// if (!this.loaded) {
		// 	_.set(this, "filters", response.data.filters ?? {});
		// }
		state.stats = response.data.stats || state.stats;
		state.loaded = true;
	},
	ADD_ITEM(state, payload) {
		state.items.unshift(payload);
		state.meta.total++;
		state.meta.last_page = Math.ceil(state.meta.total / state.meta.per_page);
		if (state.items.length > state.meta.per_page) {
			state.items.splice(state.items.length - 1, 1);
		}
	},
	UPDATE_ITEM(state, payload) {
		let items = state.items;
		let itemIndex = items.findIndex(i => i.id === payload.id);
		if (itemIndex > -1) {
			items[itemIndex] = payload;
			state.items = items;
		}
		// Vue.set(state.items, state.items.findIndex(i => i.id === payload.id), payload);

		if (state.activeItem?.id === payload.id) {
			state.activeItem = payload;
		}
	},
	SET_ACTIVE_ITEM(state, payload) {
		state.activeItem = payload;
	},
	unshift(state, {key, value, id}) {
		if (!key || !id) {
			return;
		}

		let path = key.split(".");
		key = path.slice(-1);
		path = path.slice(0, -1).join(".");
		let node = !path ? state.activeItem : _.get(state.activeItem, path);

		if (node.id === id) {
			node[key].unshift(value);
		}
	},
};

const getters = {
	activeItem(state) {
		return state.activeItem;
	},
	sortedItems: state => sortingFunction => {
		if (!sortingFunction) {
			sortingFunction = (item1, item2) => {
				if (!("timestamp" in item1 && "timestamp" in item2)) return 0;
				if (item1.timestamp < item2.timestamp) return 1;
				if (item1.timestamp > item2.timestamp) return -1;
				return 0;
			};
		}
		let itemsToReturn = Object.values(state.items);
		return itemsToReturn.sort(sortingFunction);
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
